import { createContext, useContext, type ReactNode } from "react";
import type { DashboardGateway } from "../infrastructure/dashboard.gateway";

const Contexto = createContext<DashboardGateway | null>(null);

export function ProvedorDeDashboard({
  gateway,
  children,
}: {
  readonly gateway: DashboardGateway;
  readonly children: ReactNode;
}) {
  return <Contexto.Provider value={gateway}>{children}</Contexto.Provider>;
}

export function useDashboardGateway(): DashboardGateway {
  const gateway = useContext(Contexto);
  if (!gateway) {
    throw new Error("useDashboardGateway fora do ProvedorDeDashboard");
  }
  return gateway;
}
